import { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { ModeDocumentsPageType } from '../types';
import { smx3 } from '../slices/categoriesActions';
import { useSearchParams } from 'react-router-dom';
import { useDocumentsNavigateTo } from './useDocumentsNavigateTo';

export const useParamsSmx3Documents = ({ mode = 'documents' }: { mode?: ModeDocumentsPageType } = {}) => {
    const dispatch = useAppDispatch();
    const { navigateTo } = useDocumentsNavigateTo();
    const [searchParams] = useSearchParams();
    const smxId = searchParams.get('smxId');

    useEffect(() => {
        (async () => {
            if (smxId) {
                const res = await dispatch(smx3(smxId));
                if (res.payload) {
                    navigateTo(res.payload);
                }
            }
        })();
    }, [smxId]);

    return smxId;
};
